import core from '../app.core.module.js';
import errorpageConfig from './errorpage.config.js';
import errorpageRoute from './errorpage.route.js';
import errorpageController from './errorpage.controller.js';

angular.module('errorpage', [
  // Shared modules.
  core
])
// Register config.
.config(errorpageConfig)
// Register route.
.config(errorpageRoute)
// Register controller.
.controller('errorpageController', errorpageController)

export default 'errorpage';


// WEBPACK FOOTER //
// ./src/errorpage/errorpage.module.js